import { Edge } from '@/data/types/Compare';
import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorDrawerContainerSX = (
	_edges?: Edge,
	bottom: number | string = 0
): SxProps => ({
	// edge is not used in this function, leave it for backward compatibility of the function signature.
	position: 'fixed',
	top: 'auto',
	bottom,
	left: 0,
	width: '100vw',
	background: 'white',
});
